import {connectorTypes} from "./type";
import {BaseAction} from "../../actions/base";

const types = connectorTypes;

const path = `iot/connector`;

const base = new BaseAction(types);

export const getConnectorDatas = () => (dispatch) => {
    return base.getDatas(path, dispatch);
};

export const getDeletedConnectorDatas = () => (dispatch) => {
    return base.getDatas(`${path}/deleted`, dispatch);
};

export const getConnectorData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}`, dispatch);
};

export const getDeletedConnectorData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}/deleted`, dispatch);
};

export const addConnectorData = (newData) => (dispatch) => {
    return base.addData(path, dispatch, newData);
};

export const editConnectorData = (id, newData) => (dispatch) => {
    return base.editData(`${path}/${id}`, dispatch, newData);
};

export const deleteConnectorData = (id) => (dispatch) => {
    return base.deleteData(`${path}/${id}`, dispatch, id);
};

export const restoreConnectorData = (id) => (dispatch) => {
    return base.restoreData(`${path}/${id}/restore`, dispatch, id);
};

export const hardDeleteConnectorData = (id) => (dispatch) => {
    return base.hardDeleteData(`${path}/${id}/confirmdelete`, dispatch, id);
};
